var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',{attrs:{"title-translation-key":"livedata.displayer.actions.edit","icon-descriptor":{ name: 'edit' },"handler":_vm.handler,"close-popover":_vm.closePopover}})
}
var staticRenderFns = []

export { render, staticRenderFns }